import { render, staticRenderFns } from "./ExpedienteCoplacaProductoresActionsCellRenderer.vue?vue&type=template&id=77933859"
import script from "./ExpedienteCoplacaProductoresActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./ExpedienteCoplacaProductoresActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports